import * as React from "react";
const SvgFiRrProblemSolving = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-problem-solving_svg__a)">
      <path
        fill="#062147"
        d="m23.707 22.293-2.54-2.54A4.97 4.97 0 0 0 21.999 17c0-2.757-2.242-5-5-5-2.756 0-5 2.243-5 5s2.243 5 5 5a4.97 4.97 0 0 0 2.754-.833l2.54 2.54a.997.997 0 0 0 1.413 0 1 1 0 0 0 0-1.414M13.998 17c0-1.654 1.346-3 3-3 1.655 0 3 1.346 3 3s-1.345 3-3 3c-1.653 0-3-1.346-3-3m-2.5-4a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 .001M11 6v3a1 1 0 1 1-2 0V6a1 1 0 1 1 2 0m-1 11a1 1 0 0 1-1 1H3.08a3.04 3.04 0 0 1-2.664-1.541 3.04 3.04 0 0 1 .008-3.079L7.3 1.531A3.05 3.05 0 0 1 9.96 0a3.04 3.04 0 0 1 2.656 1.529l4.034 6.97c.277.478.114 1.09-.363 1.367a1 1 0 0 1-1.367-.365L10.89 2.533c-.393-.676-1.462-.678-1.858.003L2.15 14.385a1.05 1.05 0 0 0-.003 1.077c.196.341.536.538.93.538H9a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-problem-solving_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrProblemSolving;
